import {
  RecoSectionContent,
  TrackingPageTypeWithId,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk'
import CdnImage from 'components/CdnImage'
import { exists } from 'helpers/exists'
import { ElementTrackingContextProvider } from 'helpers/tracking/ElementTrackingContext'
import { RecoSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import { PromotionImpression } from 'helpers/tracking/trackerComponents/ElementTracker'
import React from 'react'
import { Link } from 'react-router-dom'
import { useService } from 'services/utils/context'
import styles from './styles.module.scss'

interface Props {
  brandIds: string[]
}

const TopBrands: React.FC<Props> = ({ brandIds }) => {
  const service = useService()

  const filteredTopBrandRecommendations = brandIds
    .map(brandId => service.brands.getByBrandId(brandId))
    .filter(exists)
    .filter(topBrand => exists(topBrand.logoImageHash))

  return (
    <div className={styles.topBrands} data-testid="TopBrands">
      <RecoSectionTrackingContextProvider
        recoType={RecoSectionContent.topBrands}
        initiallyVisibleColumns={5}
      >
        {filteredTopBrandRecommendations.map(filteredTopBrandRecommendation => {
          const [brandId] = filteredTopBrandRecommendation.id.split('-')
          return (
            <ElementTrackingContextProvider
              key={filteredTopBrandRecommendation.id}
            >
              <PromotionImpression<HTMLDivElement>
                type={TrackingPageTypeWithId.Brand}
                id={brandId}
                name={filteredTopBrandRecommendation.name}
                url={filteredTopBrandRecommendation.url}
                source={TrackingPromotionCreative.BrandReco}
                useIdForDestination
              >
                {({ ref, onClickCapture }) => (
                  <div
                    onClickCapture={onClickCapture}
                    ref={ref}
                    key={filteredTopBrandRecommendation.id}
                    className={styles.brandLinkWrapper}
                  >
                    <Link
                      to={filteredTopBrandRecommendation.url}
                      className={styles.brandLink}
                    >
                      <CdnImage
                        alt={filteredTopBrandRecommendation.name}
                        className={styles.brandLogo}
                        height={150}
                        imageHash={
                          filteredTopBrandRecommendation.logoImageHash!
                        }
                        trim
                        width={150}
                      />
                    </Link>
                  </div>
                )}
              </PromotionImpression>
            </ElementTrackingContextProvider>
          )
        })}
      </RecoSectionTrackingContextProvider>
    </div>
  )
}

export default TopBrands
